import angular = require("angular");

export function initialize(module: ng.IModule) {
    module.filter("hideEmptyHierarchy", hideEmptyHierarchy);

    hideEmptyHierarchy.$inject = ["$filter"];
}

function hideEmptyHierarchy($filter: ng.IFilterService) {
    return function (items, childrenProperty: string, searchText: string, filterByProperty: string) {
        var filtered = [];

        // If no searchText then return all items
        if (!searchText) {
            return items;
            // Otherwise make the search, and only show/add non-empty hierarchies
        } else {
            angular.forEach(items, function (item) {
                if (anyChildren(item, childrenProperty) && anyMatches($filter, item[childrenProperty], searchText, filterByProperty)) {
                    filtered.push(item);
                }
            });
        }

        return filtered;
    }
}

function anyChildren(item, childrenProperty: string) {
    return item[childrenProperty] && item[childrenProperty].length > 0;
}

function anyMatches($filter: ng.IFilterService, items, searchText: string, filterByProperty: string) {
    var searchFilter: any = $filter("searchFilter");
    return searchFilter(items, searchText, filterByProperty).length > 0;
}

import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { FilterByPipe } from "./filter-by.pipe";

@Pipe({
    name: "crewHideEmptyHierarchy"
})
@Injectable()
export class HideEmptyHierarchyPipe implements PipeTransform {
    transform(items: any[], childrenProperty: string, searchText: string, filterByProperty: string): any {
        var filtered = [];

        // If no searchText then return all items
        if (!searchText) {
            return items;
            // Otherwise make the search, and only show/add non-empty hierarchies
        } else {

            for (let item of items) {
                if (this.anyChildren(item, childrenProperty) && this.anyMatches(item[childrenProperty], searchText, filterByProperty)) {
                    filtered.push(item);
                }
            }
        }

        return filtered;
    }

    public anyChildren(item: any, childrenProperty: string): boolean {
        return item[childrenProperty] && item[childrenProperty].length > 0;
    }

    public anyMatches(items: any[], searchText: string, filterByProperty: string): boolean {
        return new FilterByPipe().transform(items, searchText, filterByProperty).length > 0;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/hideemptyhierarchy.filter.ts